import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface SendMessageToClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (message: string) => void;
  clientName: string;
  loading?: boolean;
}

const SendMessageToClientModal: React.FC<SendMessageToClientModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  clientName,
  loading = false
}) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSubmit(message.trim());
    }
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.sendMessageToClient.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        <div style={{
          marginBottom: '1rem',
          padding: '1rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '4px'
        }}>
          <strong>{t('modals.sendMessageToClient.client')}:</strong> {clientName}
        </div>

        <div className="modal-form-group">
          <label htmlFor="message">{t('modals.sendMessageToClient.messageLabel')}</label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={t('modals.sendMessageToClient.messagePlaceholder')}
            required
            disabled={loading}
            rows={5}
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.sendMessageToClient.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button primary"
            disabled={loading || !message.trim()}
          >
            {loading ? t('modals.sendMessageToClient.sending') : t('modals.sendMessageToClient.send')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default SendMessageToClientModal;
